module.exports = __webpack_public_path__ + "static/media/reward2.b4efe9b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/imgs/reward2.png
// module id = 1172
// module chunks = 0